import React, { useState } from "react";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { DialogProps } from "./DialogProps";
import AnalystCommentsEditor, { AnalystComment } from '../Shared/AnalystCommentsEditor/AnalystCommentsEditor';

export interface NoteDialogProps extends DialogProps<AnalystComment[]> {
  title: string;
}

export default function NoteDialog(props: NoteDialogProps) {
  const [analystComments, setAnalystComments] = useState<AnalystComment[]>([]);
  const [errors, setErrors] = useState<string>("");

  return (
    <>
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {props.title}
      </DialogTitle>
      <DialogContent style={{width: '700px'}}>
        <AnalystCommentsEditor
          onChange={(comments: AnalystComment[]) => {
            setAnalystComments(comments);
          }}
        />  
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeDialog} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (analystComments.length > 0) {
              props.accept && props.accept(analystComments);
            } else {
              setErrors("You must enter a note");
            }
          }}
          color="primary"
          variant="contained"
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}
